import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XFilterModel } from 'src/app/shared/interfaces/x-filter.model';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  baseUrl = '/settings/api/';
  constructor(private http: HttpClient) {}

  /** Service Centers*/
  getServiceCenters(filter: any): Observable<any> {
    const headers = new HttpHeaders({
      'X-Filter': JSON.stringify(filter),
    });
    return this.http.get<any>(`${this.baseUrl}ServiceCenter/all`, { headers });
  }


  /** sub city */
  getSubCities(): Observable<any> {
    // const headers = new HttpHeaders({
    //   'X-Filter': JSON.stringify(filter),
    // });
    return this.http.get<any>(`${this.baseUrl}SubCity`);
  }

  /** woredas */
  getWoredas(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}Woredas`);
  }

  /** Institutions */
  getSettingInstitutions(filter: XFilterModel): Observable<any> {
    const headers = new HttpHeaders({
      'X-filter': JSON.stringify(filter || {}),
    });
    return this.http.get<any>(`/assessment/api/Setting/institutions`, {
      headers,
      observe: 'response',
    });
  }

  /** Campuses */
  getSettingCampuses(filter: XFilterModel): Observable<any> {
    const headers = new HttpHeaders({
      'X-filter': JSON.stringify(filter || {}),
    });
    return this.http.get<any>(`/assessment/api/Setting/campuses`, {
      headers,
      observe: 'response',
    });
  }
}
